/** Characters used in share codes: no 0/O, 1/I/L, so codes are easy to read and type. */
export const SHARE_CODE_ALPHABET = "23456789ABCDEFGHJKMNPQRSTUVWXYZ";
export const SHARE_CODE_LENGTH = 8;

const CODE_PATTERN = new RegExp(`^[${SHARE_CODE_ALPHABET}]{${SHARE_CODE_LENGTH}}$`);

/**
 * Canonical form of user-entered code: upper case, without spaces or dashes.
 * Returns null if it isn't a valid code.
 */
export function normalizeShareCode(input: string): string | null {
  const code = input.toUpperCase().replace(/[\s-]/g, "");
  return CODE_PATTERN.test(code) ? code : null;
}

/** Display form, e.g. `K7PQ-2QXH`. */
export function formatShareCode(code: string): string {
  return `${code.slice(0, 4)}-${code.slice(4)}`;
}
